import { makeRequest, CommonRequestOptions } from '../../makeRequest';
import { ColumnSettings } from './@types';

export type UpdateUserManageTableColumnsResult = {
   column_settings: ColumnSettings[];
};

export async function updateUserManageTableColumns(
   columnSettings: ColumnSettings[],
   { ...common }: CommonRequestOptions = {}
): Promise<UpdateUserManageTableColumnsResult> {
   return makeRequest('post', `users/manage_table/`, {
      body: {
         column_settings: columnSettings,
      },
      ...common,
   });
}
